import { palette } from "$lib/image/palette";
import { COMMANDS } from "$lib/commands/commands";

export function registerPaletteCommands() {
    const { add, destroy } = COMMANDS.registerActions("all");

    add("editor.tool.set-color", (color: Color) => {
        palette.index.set(-1);
        palette.primary.set(color);
    });

    add("editor.tool.palette-index", (index: number) => {
        palette.index.set(index);
        palette.primary.set(palette.active.value.colors[palette.index.value]);
    });

    add("editor.tool.palette-prev", () => {
        let index = palette.index.value;
        const max = palette.active.value.colors.length;
        if (index === -1) return false;
        index = (index - 1 + max) % max;

        palette.index.set(index);
        palette.primary.set(palette.active.value.colors[index]);
    });

    add("editor.tool.palette-next", () => {
        let index = palette.index.value;
        const max = palette.active.value.colors.length;
        if (index === -1) return false;
        index = (index + 1) % max;

        palette.index.set(index);
        palette.primary.set(palette.active.value.colors[index]);
    });

    return { destroy };
}
